import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExpired = props => /*#__PURE__*/_jsxs("svg", {
  id: "expired_svg__Ebene_1",
  x: 0,
  y: 0,
  viewBox: "0 0 24 24",
  xmlSpace: "preserve",
  width: "1em",
  height: "1em",
  ...props,
  children: [/*#__PURE__*/_jsx("style", {
    children: '.expired_svg__st0{fill:currentColor}'
  }), /*#__PURE__*/_jsx("path", {
    className: "expired_svg__st0",
    d: "M10.145 1.526a9.54 9.54 0 109.54 9.54 9.55 9.55 0 00-9.54-9.54zm0 17.717a8.177 8.177 0 118.177-8.177 8.186 8.186 0 01-8.177 8.177z"
  }), /*#__PURE__*/_jsx("path", {
    className: "expired_svg__st0",
    d: "M10.516 5.236a.689.689 0 00-.689.689v4.823H5.004a.689.689 0 000 1.378h5.512c.38 0 .689-.308.689-.689V5.925a.689.689 0 00-.689-.69z"
  }), /*#__PURE__*/_jsxs("g", {
    transform: "translate(23 19)",
    children: [/*#__PURE__*/_jsx("circle", {
      cx: -4.905,
      cy: -2.104,
      r: 5.3,
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#515151"
    }), /*#__PURE__*/_jsx("path", {
      className: "expired_svg__st0",
      d: "M-4.905-5.814c-.293 0-.53.253-.53.565v3.64c0 .312.237.565.53.565.293 0 .53-.253.53-.565v-3.64c0-.312-.237-.565-.53-.565z"
    }), /*#__PURE__*/_jsx("circle", {
      className: "expired_svg__st0",
      cx: -4.905,
      cy: 1.076,
      r: 0.53
    })]
  })]
});
export default SvgExpired;